import { type FC } from "react";
import * as styles from "./styles.css";

type ApprovalStatus = "none" | "pending" | "approved" | "remand";

const ApprovalStatusText: Record<ApprovalStatus, string> = {
  none: "下書き",
  pending: "申請中",
  approved: "承認済み",
  remand: "差し戻し",
};

type Props = {
  approvalStatus: ApprovalStatus;
};

export const ApprovalStatusLabel: FC<Props> = ({ approvalStatus }) => (
  <span className={styles.statusLabel[approvalStatus]}>{ApprovalStatusText[approvalStatus]}</span>
);
